import { ZodIssueCode } from 'zod';
export const ZodCFV = {
    id: 'ZodCFV',
    value: (Schema) => ({
        withCFV: {
            value() {
                const cfvList = Object.values(this._def.cfv || {});
                if (cfvList.length === 0) {
                    return this.refine(() => true);
                }
                else {
                    const refinedObject = cfvList
                        .map((c) => cfvToRefinement(c))
                        .reduce((acc, cur) => acc.superRefine(cur), this);
                    return refinedObject;
                }
            }
        },
        setCFV: {
            value(cfv) {
                return new Schema({
                    ...this._def,
                    cfv
                });
            }
        },
        getCFV: {
            value() {
                return this._def.cfv || {};
            }
        }
    })
};
export function cfvToRefinement(cfv) {
    return function (val, ctx) {
        const result = cfv(val);
        if (result instanceof Promise) {
            return result.then((data) => {
                if (data) {
                    ctx.addIssue({
                        code: ZodIssueCode.custom,
                        ...data
                    });
                    return false;
                }
                else {
                    return true;
                }
            });
        }
        if (result) {
            ctx.addIssue({
                code: ZodIssueCode.custom,
                ...result
            });
            return false;
        }
        else {
            return true;
        }
    };
}
